export default "/_next/static/images/food-bowl-2x-dfdea3cb63179b54bb4991db34c5a0ce.jpg";